jQuery.fn.programMap2CSV = function(options) {
		var options = jQuery.extend({
				separator: ',',
				header: [],
				delivery: 'popup' // popup, value
		},
		options);

		var csvData = [];
		var headerArr = [];
		var el = jQuery.extend(true, {}, this);

		//header
		var numCols = options.header.length;
		var tmpRow = []; // construct header avalible array

		if (numCols > 0) {
				for (var i = 0; i < numCols; i++) {
					tmpRow[tmpRow.length] = formatData(options.header[i]);
				}
		} else {
				$(el).find('th').each(function() {
					tmpRow[tmpRow.length] = '"' + $(this).find('.export-data').text().trim() + '"';
				});
		}

		row2CSV(tmpRow);

		// actual data
		$(el).find('tr').each(function() {
			var tmpRow = [];
			$(this).find('td').each(function() {
				var x = '';
				x = x + '"' + $(this).find('.export-data').text().trim() + '"';
				tmpRow[tmpRow.length] = x;
			});
			row2CSV(tmpRow);
		});

		switch(options.delivery) {
			case 'popup':
				var mydata = csvData.join('\n');
				return popup(mydata);
				break;
			case 'csv':
				var mydata = csvData.join('\n');
				return downloadCSV(mydata);
				break;
			case 'form':
				var mydata = csvData.join('\n');
				return appendAfter(mydata);
				break;
			default:
				var mydata = csvData.join('\n');
				return popup(mydata);
		}

		function removeElements(params) {
			for (var i in params.classnames) {
				cls = "." + params.classnames[i];
				$(params.content).find(cls).remove();
			}
		}

		function row2CSV(tmpRow) {
				var tmp = tmpRow.join('') // to remove any blank rows
				if (tmpRow.length > 0 && tmp != '') {
						var mystr = tmpRow.join(options.separator);
						mystr = mystr.replace(/\t/, ' '); // replace first occurance as space
						mystr = mystr.replace(/\n/, ' '); // replace first occurance as space
						mystr = mystr.replace(/\t/g, ''); // replace all the rest
						mystr = mystr.replace(/\n/g, ''); // replace all the rest
						csvData[csvData.length] = mystr;
				}
		}
		function formatData(input) {
				// replace " with “
				var regexp = new RegExp(/["]/g);
				var output = input.replace(regexp, "“");
				//HTML
				var regexp1 = new RegExp(/\<[^/]+\>/g);
				var regexp2 = new RegExp(/\<\/\w+\>/g);
				var regexp3 = new RegExp(/[\t\n]/g);
				var output = output.replace(regexp1, "");
				var output = output.replace(regexp2, ": ");
				var output = output.replace(regexp3, "");
				if (output == "") return '';
				return '"' + jQuery.trim(output) + '"';
		}

    function popup(data) {
				var generator = window.open('', 'csv', 'height=400,width=600');
				generator.document.write('<html><head><title>CSV</title>');
				generator.document.write('</head><body >');
				generator.document.write('<textArea cols=70 rows=15 wrap="off" >');
				generator.document.write(data);
				generator.document.write('</textArea>');
				generator.document.write('</body></html>');
				generator.document.close();
				return true;
		}

		function downloadCSV(data) {
			$("body").append('<form id="exportform" action="/proposal/mapCSV" method="post" target="_blank"><input type="hidden" id="exportdata" name="exportdata" /></form>');
			$("#exportdata").val(data);
			$("#exportform").submit().remove();
		}

		function appendAfter(data) {
			$('<form id="exportform" action="/proposal/mapCSV" method="post" target="_blank"><input type="hidden" id="exportdata" name="exportdata" /></form>').insertAfter('form');
			$("#exportdata").val(data);
			$("#exportform").submit().remove();
		}
};
